export default "__VITE_ASSET__xcc$vQDx__"